// ES6 module wrapper for Config
// This file is for modern bundlers (Vite, Webpack, etc.)
// Self-contained Config class for React app

class Config {
	constructor() {
		// Development flag - single source of truth
		this.isDev = false; // Same value as Config.js
		
		// Initialize configurations based on isDev
		this.initializeConfigs();
	}
	
	initializeConfigs() {
		// Firebase Configuration
		this.fbConfig = this.isDev ? {
			apiKey: "AIzaSyAIo41El-edeJbmzID5L0buan-sZgdlNhg",
			authDomain: "digicantv.firebaseapp.com",
			projectId: "digicantv",
			storageBucket: "digicantv.appspot.com",
			messagingSenderId: "1016535019069",
			appId: "1:1016535019069:web:72c8a465137699f51bc454",
			measurementId: "G-SXT597S4Z4"
		} : {
			apiKey: "AIzaSyCMofS75w_V9JvW_rl8hsG6b3Ej5cssA2k",
			authDomain: "mydigisign-63bd6.firebaseapp.com",
			projectId: "mydigisign-63bd6",
			storageBucket: "mydigisign-63bd6.appspot.com",
			messagingSenderId: "57655933309",
			appId: "1:57655933309:web:be11751b936df03e387414",
			measurementId: "G-PBVPW9PCTV"
		};

		// Stripe Configuration
		this.stripeSubscriptionsPage = this.isDev ? 
			"https://billing.stripe.com/p/login/test_eVa5lceI63e0dJSeUU" : 
			"https://billing.stripe.com/p/login/9AQ165cKq6gC5yw5kk";
		
		// App Configuration
		this.screenMaxCount = 2;
		
		// Client Ads Configuration
		this.clientAdsConfig = this.isDev ? {
			adDisplayInterval: 20000, 
			adDisplayTime: 5000, 
			adMaxCount: 6
		} : {
			adDisplayInterval: 1800000, 
			adDisplayTime: 10000, 
			adMaxCount: 6
		};
	}
	
	// Method to toggle development mode (useful for testing)
	toggleDevMode() {
		this.isDev = !this.isDev;
		this.initializeConfigs();
	}
	
	// Method to set development mode explicitly
	setDevMode(isDev) {
		this.isDev = isDev;
		this.initializeConfigs();
	}
}

// Create singleton instance
const configInstance = new Config();

// ES6 export for modern bundlers
export default configInstance; 